export enum AllocationStatus {
  Active = 0,
  Pending = 1,
  Waitlisted = 2,
  Terminated = 3,
  Cancelling = 4
}

export const AllocationStatusValues = [
  {
    name: 'Active',
    id: AllocationStatus.Active
  },
  {
    name: 'Pending',
    id: AllocationStatus.Pending
  },
  {
    name: 'Waitlisted',
    id: AllocationStatus.Waitlisted
  },
  {
    name: 'Terminated',
    id: AllocationStatus.Terminated
  },
  {
    name: 'Cancelling',
    id: AllocationStatus.Cancelling
  }
];
